const _queriesWM: WeakMap<UrlQueryBuilder, Map<string, any>> = new WeakMap();
const _queries = (o: UrlQueryBuilder) => _queriesWM.get(o)!;

export class UrlQueryBuilder {
    constructor() {
        _queriesWM.set(this, new Map());
    }

    /**
     * Vloží nový query parametr
     * @param name jméno query parametru
     * @param value hodnota
     * @param isDefaultValue funkce, která detekuje defaultní hodnotu která se nebude vkládat
     */
    public set(name: string, value: any, isDefaultValue?: (value: any) => boolean): void {
        if ((value != undefined) && (!isDefaultValue || !isDefaultValue(value)))
            _queries(this).set(name, value);
    }

    /**
     * Vrací true pokud není vložen žádný parametr
     */
    public get isEmpty(): boolean {
        return _queries(this).size == 0;
    }

    public toString(): string {
        return Array.from(_queries(this)).map(([name, value]) => `${name}=${Array.isArray(value) ? value.map((v) => encodeURIComponent(v)).join(",") : encodeURIComponent(value)}`).join("&");
    }

    public delete(name: string): void {
        _queries(this).delete(name);
    }

    public get(name: string): string | undefined {
        return _queries(this).get(name);
    }

    public has(name: string): boolean {
        return _queries(this).has(name);
    }

    public entries(): IterableIterator<[string, string]> {
        return _queries(this).entries();
    }

    public [Symbol.iterator](): IterableIterator<[string, string]> {
        return this.entries();
    }

    public values(): IterableIterator<string> {
        return _queries(this).values();
    }

    public keys(): IterableIterator<string> {
        return _queries(this).keys();
    }
}
